// ELESOCIETY Theme JS

// Size selector
document.querySelectorAll('.ele-sizes').forEach(group => {
  group.addEventListener('click', e => {
    const btn = e.target.closest('.ele-size-btn');
    if (!btn || btn.disabled) return;
    group.querySelectorAll('.ele-size-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');

    // Update hidden variant input
    const card = group.closest('.ele-card');
    if (card) {
      const variantId = btn.dataset.variantId;
      const variantInput = card.querySelector('[name="id"]');
      if (variantInput && variantId) variantInput.value = variantId;
    }
  });
});

// Add to cart
document.querySelectorAll('.ele-add-btn').forEach(btn => {
  btn.addEventListener('click', async () => {
    const card = btn.closest('.ele-card');
    const variantInput = card ? card.querySelector('[name="id"]') : null;
    const variantId = variantInput ? variantInput.value : null;

    if (!variantId) {
      btn.textContent = 'Elige talla';
      setTimeout(() => { btn.textContent = 'Añadir al carrito'; }, 1400);
      return;
    }

    const orig = btn.textContent;
    btn.textContent = '...';
    btn.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

      if (res.ok) {
        btn.textContent = 'Añadido ✓';
        btn.style.background = 'var(--cream)';
        btn.style.color = 'var(--black)';
        updateCartCount();
      } else {
        btn.textContent = 'Sin stock';
      }
    } catch (e) {
      btn.textContent = 'Error';
    }

    setTimeout(() => {
      btn.textContent = orig;
      btn.style.background = '';
      btn.style.color = '';
      btn.disabled = false;
    }, 1600);
  });
});

async function updateCartCount() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    const countEl = document.querySelector('.ele-cart-count');
    if (countEl) {
      countEl.textContent = cart.item_count;
      countEl.classList.toggle('active', cart.item_count > 0);
    }
  } catch (e) {}
}

updateCartCount();

// Mobile menu toggle
(function () {
  const toggle = document.querySelector('.ele-nav-toggle');
    const menu = document.querySelector('.ele-mobile-menu');
      if (!toggle || !menu) return;
        function setOpen(open) {
            toggle.classList.toggle('open', open);
                menu.classList.toggle('open', open);
                    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
                        document.body.classList.toggle('ele-menu-open', open);
                          }
                            toggle.addEventListener('click', function () {
                                setOpen(!menu.classList.contains('open'));
                                  });
                                    menu.querySelectorAll('a').forEach(function (link) {
                                        link.addEventListener('click', function () { setOpen(false); });
                                          });
                                          })();
                                          